<template>
  <div class="bg-round bg-fff">
    <div class="container">
      <div class="bg-fff" id="w-1200px">
        <Bread :list="breadList" class="ma-t-10" />
      </div>
      <div class="ma-t-40">
        <div class="fon-26 t-center font-bold">
          {{ detail.Name }}
        </div>
        <div class="flex f-around ma-t-30">
          <div>
            <i class="el-icon-time"></i>
            {{ detail.ReleaseTime }}
          </div>
          <div>
            <i class="el-icon-view"></i>
            {{ detail.ViewCount }}人预览
          </div>
          <div>
            <i class="el-icon-menu"></i>
            {{ detail.CategoryName }}
          </div>
        </div>
      </div>
      <div>
        <img src="../img/index/index21.png" class="width100" alt="" srcset="" />
      </div>
      <div class="ma-t-40 lh-html main-md" v-html="content"></div>
      <div v-if="detail && detail.FileList && detail.FileList.length>0" class="pa-30 ma-t-30">
        <div class="fon-22 font-bold">相关附件</div>
        <div v-for="(item,index) in detail.FileList" :key="index" class="flex f-between pa-tb-20 b-b-1-e3">
          <div>{{ item.Name }}.{{ item.Type }}</div>
          <div> <a :href="item.Url">下载</a> </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { newsDetail } from "../api.js";
export default {
  data() {
    return {
      breadList: [
        {
          name: "新闻中心",
          path: "/news/index",
        },
        {
          name: "正文",
          path: "",
        },
      ],
      id:null,
      detail:null,
      content:"",
    };
    
  },
  created(){
    this.id=this.$route.query.id
    this.loadData()
  },
  methods:{
    loadData() {
      newsDetail({ id: this.id }).then((res) => {
        this.detail = res.data.Data;
        this.content=res.data.Data.Content.replace(/crossorigin="anonymous"/g,"");
      });
    },
  },
  watch:{
    '$route.query.id'(val){
      if(val){
        this.id= this.$route.query.id
        this.isVideoPlay=false
        this.loadData()
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  min-height: 1150px;
  box-sizing: border-box;
  padding: 30px 0px;
}
.main-md {
    padding-left: 181px;
    padding-right: 210px;
}
</style>